<div mat-subheader *ngIf="item.navCap && !collapsed" class="nav-caption">
  {{ item.navCap }}
</div>
<a mat-list-item
  (click)="onItemSelected(item)"
 [ngClass]="{'selected-nav-item': isMenuActive(item.activeMatchRoute || item.route)}"
  class="menu-list-item"
  [class.collapsed-item]="collapsed"
  *ngIf="!item.navCap"
  [matTooltip]="collapsed ? item.displayName : ''"
  matTooltipPosition="right"
  matTooltipClass="custom-tooltip"
>
  <span class="material-icons icon-outline">{{ item.iconName }}</span>
  <span class="hide-menu" *ngIf="!collapsed">{{ item.displayName }}</span>
</a>
<style>
  .material-icons {
    font-family: 'Material Symbols Outlined',sans-serif !important;
    font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24;
    transition: font-variation-settings 0.25s ease;
    margin: 0.5rem;
    padding: 0;
    font-size: 1.5rem;
  }

  .material-icons.icon-outline {
    font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;
  }

  .selected-nav-item {
    color: white !important;
    background-color: #C8DAEA;
  }

  .selected-nav-item .material-icons {
    font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24;
  }

  .hide-menu {
    margin: 0;
    padding: 0;
    text-align: left;
    flex-grow: 1;
    font-size: 1rem;
    color: var(--Text-Primary, #000);
    font-style: normal;
    font-weight: 500;
    line-height: 1.25rem;
    font-family: 'Inter', sans-serif;
  }
</style>